import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';

class AboneListeAPI extends BaseAPI {


  constructor() {
    const baseUrl = environment.API_URL + "AboneListe";
    super(baseUrl);
  }


  getAboneListe(bolgeKodu?: number, mahalleKodu?: number, caddeSokakKodu?: number, disKapiNo?: string, icKapiNo?: string, aboneNo?: number, sayacNo?: string) {

    return this.get("", {params:{bolgeKodu:bolgeKodu, mahalleKodu:mahalleKodu,caddeSokakKodu:caddeSokakKodu,disKapiNo:disKapiNo,icKapiNo:icKapiNo,aboneNo:aboneNo,sayacNo:sayacNo}});

  }

}
export default new AboneListeAPI();
class AboneListeRequest {
  public bolgeKodu?: number;
  public mahalleKodu?: number;
  public caddeSokakKodu?: number;
  public disKapiNo?: string;
  public icKapiNo?: string;
  public aboneNo?: number;
  public sayacNo?: string;

  constructor(bolgeKodu?: number, mahalleKodu?: number, caddeSokakKodu?: number, disKapiNo?: string, icKapiNo?: string, aboneNo?: number, sayacNo?: string) {

    this.bolgeKodu = bolgeKodu;
    this.mahalleKodu = mahalleKodu;
    this.caddeSokakKodu = caddeSokakKodu;
    this.disKapiNo = disKapiNo;
    this.icKapiNo = icKapiNo;
    this.aboneNo = aboneNo;
    this.sayacNo = sayacNo;

  }
}
export { AboneListeRequest };